import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom'
import Select from 'react-select'

const SelectRefinement = connectRefinementList(({
    refine,
    items,
    placeholder,
    currentRefinement
}) => {

    const dressLabel = (label) => {
        if(placeholder === "Access") {
            return label + " Performance";
        }
        return label;
    }

    const currentValue = () => {
        if (currentRefinement.length > 0) {
            const refinemntString = currentRefinement.join('')
            return {
                value: refinemntString,
                label: refinemntString
            }
        } else {
            return null
        }
    }

    return <Select theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
            ...theme.colors,
            primary25: '#f9f4f2',
            primary: '#E30614'
        },
    })}
    className='react-select-container' 
    isSearchable={false} 
    classNamePrefix='react-select' 
    value={currentValue()} 
    isClearable 
    getOptionLabel={option => dressLabel(option.label)}
    getOptionValue={option => option.id}
    options={items}

    placeholder={placeholder} 
    onChange={(option)=>{
        if (option) {
            refine(option.label)
        } else {
            refine('')
        }

    }}/>
})

export default SelectRefinement



// WEBPACK FOOTER //
// ./src/whatson/components/SelectRefinement.js